import React, { useState, useEffect } from "react"
import styled from "@emotion/styled"
import { css } from '@emotion/core'
import { CloseButton } from "./close";

import rectangleSVG from '../../assets/number-rectangle.svg';
import backgroundImg from '../../assets/dots-red-texture.svg';
import { themeColor } from '../layout/global-style';
import { Fade } from "../atoms/fade";

const Container = styled.div`
    position: absolute; 
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #000000c8; 
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;
    overflow: hidden;
`
const Wrapper = styled.div`
    position: relative;
    width: 640px;    
    max-height: 100%;
    display: flex;
    padding: 32px;
    max-width: 100%;
`

const isInvertColors = (props) => !props.invert ? css`` :
    css`
    border-color: ${themeColor.black}; 
    color: ${themeColor.black};   
    background-image: url(${backgroundImg});   
    background-size: auto;   
    padding: 54px 64px 20px; 
`

export const Frame = styled.div`
    position: relative;
    padding: 48px 40px 56px;
    background-color: ${themeColor.white};
    border-color: ${themeColor.red};
    border-width: 2px;
    border-style: solid;    
    overflow: hidden;
    display: flex;
    
    &::-webkit-scrollbar {
        width: 18px;        
    }

    &::-webkit-scrollbar-track {    
    }
    
    &::-webkit-scrollbar-thumb {
        background-color: ${props => props.invert ? "rgba(0, 0, 0, 0.7)" : "rgba(0, 241, 255, 0.7)"};
        border: 6px solid;    
        border-left-width: 4px;  
        border-color: ${props => props.invert ? themeColor.red : themeColor.black};
    }

    ${isInvertColors}
`

const Content = styled.div`    
    font-family: ff-good-web-pro-condensed, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 1.2em;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;

    h1, h5  {        
        font-family: ff-good-web-pro-condensed, sans-serif;
        font-weight: normal;
        font-style: normal;
        &:lang(pt-br) , &:lang(pl), &:lang(ru), &:lang(es), &:lang(fr){
            font-family: ff-good-web-pro-condensed, sans-serif;
        }
    }
    h1 {
        font-size: 2em;
        line-height: 1.2;
        margin-bottom: 1em;
        @media screen and (max-width: 460px) {
            font-size: 1.6em;
        }
    }

    h2 {
        font-family: ff-good-web-pro-condensed, sans-serif;
        font-weight: 700;
        font-style: normal;
        text-transform: uppercase;
        font-size: 1.1em;
        margin-bottom: 0.4em;
        line-height: 1.1em;
    }

    h5 {
        mask: url(${rectangleSVG}) no-repeat;
        background-color: ${props => props.invert ? themeColor.black : themeColor.white};
        color: ${props => props.invert ? themeColor.white : themeColor.black};
        padding: 4px 20px 4px 10px; 
        mask-size: 100% 100%;
        display: inline-block;       
    }
`

const CloseContainer = styled.div`
    position: absolute !important;
    top: 62px;
    right: 62px;
    left: 62px;
    display: flex;
    justify-content: flex-end;
    @media screen and (max-width: 772px) {
        left: auto;
        right: 20px;
        top: 14px;
        width: 46px;
    }
`

export const Modal = ({ onClose, onHidden, invert, html, isClose, isOpen, ...props }) => {
    const [showModal, setShowModal] = useState(isOpen);
    const handleModalClose = () => {
        setShowModal(false);
        if (onClose) onClose();
    };

    useEffect(() => {
        setShowModal(isOpen);
    }, [isOpen]);

    return (
        <Fade isShow={showModal} zIndex={100} onHidden={onHidden}>
            <Container className={props.className} onClick={handleModalClose}>
                <Wrapper>
                    <Frame invert={invert} className={"modal-frame"} onClick={(e) => { e.stopPropagation(); }}>
                        <Content invert={invert} dangerouslySetInnerHTML={html ? { __html: html } : undefined}>{props.children}</Content>
                    </Frame>
                    {isClose ? (
                        <CloseContainer className={"modal-close"}><CloseButton color={invert ? themeColor.black : undefined} onClick={handleModalClose} /></CloseContainer>
                    ) : null}
                </Wrapper>
            </Container>
        </Fade>
    )
}

export default Modal;
